import { motion } from "framer-motion";

export default function ModeToggle({ theme, setTheme }) {
  return (
    <motion.button
      whileTap={{ scale: 0.92 }}
      className="mode-toggle"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
    >
      {theme === "dark" ? "🌙 Dark" : "☀️ Light"}
    </motion.button>
  );
}
